import generator from "webgl-sdf-generator";
/**
 * Lazy initialization wrapper over "webgl-sdf-generator"
 */
export class SDFGenerator {
    static get module() {
        if (this.MODULE === null) {
            this.MODULE = generator();
        }
        return this.MODULE;
    }
}
SDFGenerator.MODULE = null;
